// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

import { openSnackbar } from './notify';
import { displayBackdrop, hideBackdrop } from './loading';
import { setContactUnRead } from '../reducers/contactUnRead';

const API_URL = process.env.REACT_APP_API_URL;

// Define a service using a base URL and expected endpoints
export const dashboardService = createApi({
    reducerPath: 'dashboardService',
    baseQuery: fetchBaseQuery({ baseUrl: API_URL }),
    endpoints: (builder) => ({
        getDashboard: builder.query({
            query: () => `dashboard`,
            async onQueryStarted(arg, { dispatch, queryFulfilled }) {
                dispatch(displayBackdrop());
                try {
                    const { data } = await queryFulfilled;
                    if(data){
                        dispatch(hideBackdrop());
                        dispatch(setContactUnRead(data['contactCount']));
                    }
                } catch (err) {
                    const { error } = err;
                    dispatch(hideBackdrop());
                    dispatch(openSnackbar({ options: { variant: "error" }, message: error?.data?.message || 'Something went wrong, Please try again.' }));
                }
            },
            transformResponse: (response) => response.data,
        })
    }),
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetDashboardQuery } = dashboardService;